class RechargeSDKHelper {
    async _authLogin() {
        window.rechargeSession = window.rechargeSession ?? await recharge.auth.loginShopifyAppProxy();
    }
    async _getCustomerPortalLink() {
      try{
        return await recharge.customer.getCustomerPortalAccess(window.rechargeSession);
      }catch{}
    }

    async _getCustomerDetails(include = ['addresses', 'payment_methods', 'subscriptions']) {
        await this._authLogin();
        try {
            return await recharge.customer.getCustomer(
                window.rechargeSession, {
                    include: include
                }
            );
        } catch (error) {
            console.error('Error fetching customer details', error.message)
        }
    }

    async _getSubscriptionCharges(id, status = null) {
        try {
            let config = {
                limit: 100,
                sort_by: 'id-asc',
                purchase_item_id: id,
            }
            if (status) {
                config['status'] = status;
            }
            const response = await recharge.charge.listCharges(window.rechargeSession, config);
            return response.charges;
        } catch (error) {
            console.error('Error fetching total charges', error.message)
        }
    }

    async _processCharge(id) {
        try {
            return await recharge.charge.processCharge(window.rechargeSession, id);
        } catch (error) {
            console.error('Error processing charge', error.message)
            return false;
        }
    }

    async _getSinglePaymentMethod(id) {
        try {
            return await recharge.paymentMethod.getPaymentMethod(window.rechargeSession, id);
        } catch (error) {
            console.error('Error fetching payment method', error.message)
        }
    }

    async _getPlan(id) {
      try {
          return await recharge.plan.listPlans(window.rechargeSession);
      } catch (error) {
          console.error('Error getting plan', error.message)
      }
    }
    
    async _getDeliverySchedule() {
        try {
            let config = {
                status: 'queued',
                future_interval: 365,
                limit: 100,
                sort_by: 'id-asc',
            }
            return await recharge.customer.getDeliverySchedule(window.rechargeSession, config);
        } catch (error) {
            console.error('Error fetching upcoming charges', error.message)
        }
    }

    async _cancelSubscription(subscription_id, reason, feedback) {
        try {
            let config = {
                cancellation_reason: reason,
                cancellation_reason_comments: feedback
            }
            return await recharge.subscription.cancelSubscription(window.rechargeSession, subscription_id, config);
        } catch (error) {
            console.error('Error cancelling subscription', error.message);
        }
    }

    async _reActivateSubscription(subscription_id) {
        try {
          return await recharge.subscription.activateSubscription(window.rechargeSession, subscription_id);
        } catch (error) {
            console.error('Error reactivating', error.message);
            return false;
        }
    }

    async _changeShippingAddress(addressId, updatedAddressObj) {
        try {
            return await recharge.address.updateAddress(window.rechargeSession, addressId, updatedAddressObj);
        } catch (error) {
            if (error.status === 422) {
                notificationEle.updateNotification("Enter valid address", 'Please check province and zipcode', {
                    type: "error",
                    timeout: 2000
                });
                console.error('Error updating address', error);
            } else {
                notificationEle.updateNotification("Something went wrong", "Error in updating address", {
                    type: "error",
                    timeout: 2000
                });
                console.error('Error updating address', error);
            }
            return false;
        }
    }

    async _updateSubscription(subscription_id, updateSubscriptionObj) {
        try {
            return await recharge.subscription.updateSubscription(window.rechargeSession, subscription_id, updateSubscriptionObj);
        } catch (error) {
            console.error('Error updating subscription', error.message);
            return false;
        }
    }

    async _updateSubscriptionChargeDate(subscription_id, updateSubscriptionObj) {     
      try {
        return await recharge.subscription.updateSubscriptionChargeDate(
          window.rechargeSession,
          subscription_id,
          updateSubscriptionObj.next_charge_scheduled_at
        );
      } catch (error) {
        console.error("Error updating subscription Charge Date", error.message);
        return false;
      }
    }

    async _getOrders(currentSubscriptionId, orderStatusFilter = 'success') {
        await this._authLogin();
        try {
            const request = {
                limit: 100,
                sort_by: 'processed_at-desc',
                purchase_item_id: currentSubscriptionId
            };
            if (orderStatusFilter) {
                request.status = orderStatusFilter;
            }
            return await recharge.order.listOrders(window.rechargeSession, request);
        } catch (error) {
            console.error('Error fetching orders', error.message);
            return false;
        }
    }

    async _getOrder(orderId) {
        await this._authLogin();
        try {
            return await recharge.order.getOrder(window.rechargeSession, orderId);
        } catch (error) {
            console.error('Error fetching order', error.message);
            return false;
        }
    }

    async _getListSuccessOrder(currentSubscriptionId) {
        await this._authLogin();
        try {
            const response = await recharge.order.listOrders(window.rechargeSession, {
                limit: 100,
                sort_by: "id-asc",
                purchase_item_id: currentSubscriptionId,
                status: 'success'
            });
            return await response;
        } catch (error) {
            console.error('Error fetching successfully orders', error.message);
            return false;
        }
    }


    async _getListQueuedOrder(currentSubscriptionId) {
      await this._authLogin();
      try {
          const response = await recharge.order.listOrders(window.rechargeSession, {
              limit: 100,
              sort_by: "id-asc",
              purchase_item_id: currentSubscriptionId,
              status: 'queued'
          });
          return await response;
      } catch (error) {
          console.error('Error fetching successfully orders', error.message);
          return false;
      }
    }

    async _getBoxProductsForSubscription(subscription) {
        const boxSequence = subscription.properties.find(prop => prop.name === 'box_sequence') || subscription.properties.find(prop => prop.name === '_box_sequence');
        let boxProducts;
        if (window.subscriptions.enable_box_sequence && boxSequence) {
            await fetch('/products/build-box-subscription?view=box-sequence', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            }).then(response => {
                return response.json();
            }).then(response => {
                try {
                    const boxSequences = response.box_sequences;
                    boxProducts = boxSequences[boxSequence.value];
                } catch (e) {
                    console.error(e)
                }
            });
        } else {
            boxProducts = JSON.parse(document.querySelector('[data-box-products]').innerText);
        }
        return boxProducts;
    }


    async _getHackPackProductsForSubscription(subscription) {
      const boxSequence = subscription.properties.find(prop => prop.name === 'box_sequence') || subscription.properties.find(prop => prop.name === '_box_sequence');;
      let boxProducts;
      if (window.subscriptions.enable_box_sequence && boxSequence) {
          await fetch('/products/hack-pack-subscription?view=hack-sequence', {
              method: 'GET',
              headers: {
                  'Content-Type': 'application/json',
              }
          }).then(response => {
              return response.json();
          }).then(response => {
              try {
                  const boxSequences = response.box_sequences;
                  boxProducts = boxSequences[boxSequence.value];
              } catch (e) {
                  console.error(e)
              }
          });
      } else {
          boxProducts = JSON.parse(document.querySelector('[data-hackpack-products]').innerText);
      }
      return boxProducts;
    }

    async _searchSubscriptionTypeProducts(ids) {
        try {
            const response = await recharge.product.productSearch(window.rechargeSession, {
                limit: 25,
                format_version: '2022-06',
                external_product_ids: ids,
                has_plans: true,
                in_stock: true
            });
            return await response;
        } catch (error) {
            console.error('Error searching products', error.message);
            return false;
        }
    }

    async _addShippingAddress(address) {
        try {
            return await recharge.address.createAddress(window.rechargeSession, address);
        } catch (error) {
            if (error.status === 422) {
                notificationEle.updateNotification("Enter valid address", 'Please check province and zipcode', {
                    type: "error",
                    timeout: 2000
                });
                console.error('Error adding address', error);
            } else {
                notificationEle.updateNotification("Something went wrong", "Error in adding address", {
                    type: "error",
                    timeout: 2000
                });
                console.error('Error adding address', error);
            }
            return false;
        }
    }

    async _createSubscription(subscription) {

        try {
            return await recharge.subscription.createSubscription(
                window.rechargeSession, subscription
            );
        } catch (error) {
            console.error('Error creating subscription', error.message);
            return false;
        }
    }


    async _getSubscription(subscription) {
      try {
          return await recharge.subscription.getSubscription(
              window.rechargeSession, subscription
          );
      } catch (error) {
          console.error('Error getting subscription', error.message);
          return false;
      }
  }
  async _getActiveChurnLandingPageURL(id, url) {
    return await recharge.customer.getActiveChurnLandingPageURL(window.rechargeSession, id, `https://www.crunchlabs.com/account`)
  }


}

window.rechargeHelper = new RechargeSDKHelper();